module.exports = __webpack_public_path__ + "media/images/emblems/Bottighofen-13cbd857c2d1bb26f86c33020f70b23c.png";